import { render, staticRenderFns } from "./ProductCopy.vue?vue&type=template&id=97424ef2&"
import script from "./ProductCopy.vue?vue&type=script&lang=ts&"
export * from "./ProductCopy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports